import { debounce } from 'lodash-es';
import { ref } from 'vue';

export function useDebouncedFn<T extends (...args: any[]) => void>(
    fn: T,
    delay = 300,
    options?: {
    immediate?: boolean,
    onDebounceStart?: () => void,
    onDebounceEnd?: () => void,
    skipFirst?: boolean
  },
) {
    const isDebouncing = ref(false);
    let isFirstCall = true;

    const wrapped = debounce((...args: Parameters<T>) => {
        options?.onDebounceStart?.();
        isDebouncing.value = true;

        fn(...args);

        isDebouncing.value = false;
        options?.onDebounceEnd?.();
    }, delay);

    const trigger = (...args: Parameters<T>) => {
        if (options?.skipFirst && isFirstCall) {
            isFirstCall = false;
            return fn(...args);
        }
        return wrapped(...args);
    };

    return {
        debouncedFn: trigger,
        cancel: wrapped.cancel,
        flush: wrapped.flush,
        isDebouncing,
    };
}
